module.exports = __webpack_public_path__ + "static/media/face0.1634e869.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face0.svg
// module id = 1220
// module chunks = 2